import { Either } from "fp-ts/lib/Either";
import ExceptionEntity from "../entities/ExceptionEntity";
import BucketEntity from "../entities/BucketEntity";
import UserEntity from "../entities/UserEntity";

export default interface BucketRepository {
    getAll: () => Promise<Either<ExceptionEntity, BucketEntity[]>>;
    getUsersInBucket: (bucketId: number, page: number, perPage: number) => Promise<Either<ExceptionEntity, UserEntity[]>>;
    moveUserToBucket: (userId: string, location: string, client: string, supervisor: string) => Promise<Either<ExceptionEntity, string>>;
}

export const BucketRepositoryName = "BucketRepositoryName";
